var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconElevatorUpActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
    fill: "#6cd46c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM10 19C5 19 1 15 1 10C1 5 5 1 10 1C15 1 19 5 19 10C19 15 15 19 10 19Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8657 15.9998H7.14434C6.51338 15.9998 6 15.4864 6 14.8555V9.13409C6 8.50313 6.51338 7.98975 7.14434 7.98975H12.8657C13.4967 7.98975 14.0101 8.50313 14.0101 9.13409V14.8555C14.0101 15.4864 13.4967 15.9998 12.8657 15.9998ZM10.5772 14.8555H12.8657V9.13409H10.5772V14.8555ZM7.14434 9.13409V14.8555H9.43286V9.13409H7.14434Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4548 6.58724C10.6123 6.74479 10.8188 6.82345 11.0252 6.82345C11.2317 6.82345 11.4379 6.74479 11.5954 6.58724C11.9105 6.27214 11.9105 5.76149 11.5954 5.44639L10.3853 4.23633C10.0702 3.92122 9.55959 3.92122 9.24449 4.23633L8.03467 5.44639C7.71956 5.76149 7.71956 6.27214 8.03467 6.58724C8.34977 6.90234 8.86041 6.90234 9.17552 6.58724L9.81516 5.9476L10.4548 6.58724Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElevatorUpActive);
export default __webpack_public_path__ + "static/media/icon-elevator-up-active.d353d9ada882efdbf564473d0065b6fd.svg";
export { ForwardRef as ReactComponent };